module.exports = __webpack_public_path__ + "static/media/html5.2b966376.svg";